var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportLinkedin54(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 20.4H13.6V34.5H17.8V20.4Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 20C27.1 20 25.7 21.2 25.1 22.2V22.3H24.8V20.3H20.8V34.4H25V27.5C25 25.7 25.3 23.7 27.8 23.7C30.2 23.7 30.2 26 30.2 27.6V34.4H34.4V26.7C34.4 22.7 33.5 20 29.2 20Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 13.2C14.2 13.2 13.1 14.3 13.1 15.7C13.1 17.1 14.2 18.2 15.6 18.2C17 18.2 18.1 17.1 18.1 15.7C18.1 14.3 17 13.2 15.6 13.2Z",
    fill: "#010101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8 7.59998H11.2C9.20001 7.59998 7.60001 9.29998 7.60001 11.2V36.8C7.60001 38.8 9.30001 40.4 11.2 40.4H36.8C38.8 40.4 40.4 38.7 40.4 36.8V11.2C40.4 9.19998 38.8 7.59998 36.8 7.59998ZM37.7 36.8C37.7 37.3 37.3 37.7 36.8 37.7H11.2C10.7 37.7 10.3 37.3 10.3 36.8V11.2C10.3 10.7 10.7 10.3 11.2 10.3H36.8C37.3 10.3 37.7 10.7 37.7 11.2V36.8Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportLinkedin54);
export default __webpack_public_path__ + "static/media/icons-2_export-LINKEDIN-54.ccc9cacd3bcee67eb4d65d78e137284d.svg";
export { ForwardRef as ReactComponent };